var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wl-rich-text flex-direction-column" },
    [
      _c("el-input", {
        ref: "myQuillEditorInput",
        staticClass: "wl-rich-text-input",
        model: {
          value: _vm.richTextValue,
          callback: function ($$v) {
            _vm.richTextValue = $$v
          },
          expression: "richTextValue",
        },
      }),
      _c("quill-editor", {
        ref: "myQuillEditor",
        attrs: {
          disabled:
            _vm.$$isDisabled(_vm.disabled) || _vm.$$isReadonly(_vm.readonly),
          options: _vm.$attrs,
        },
        model: {
          value: _vm.richTextValue,
          callback: function ($$v) {
            _vm.richTextValue = $$v
          },
          expression: "richTextValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }